export const LOGIN = '/login'
export const PRODUCT = '/product'
export const MATERAIAL = '/material'
export const CATEGORY = '/category'
export const USER = '/userAdmin'
export const APP_CONFIG = '/app-config'
export const APPUSER = '/user'
export const BARCODE = '/barcode'
export const HERO = '/hero'
export const MAP = '/map'
export const HEROLINK = '/heroLink'
export const HERONEWS = '/hero-news-item'
export const NEWS = '/newsItem'
export const BANNERS = '/bannersItem'
export const DOCUMENTS = '/document'
export const HEROPROMOTE = '/heroPromote'
export const HERO_GROUP_SELLING = '/heroSelling'
export const HEROCOIN = '/heroCoin'
export const LOMA = '/loma'
export const TRUCK = '/truck'
export const REMARK = '/remark'
export const BRAND = '/brand'
export const BRAND_NEWS = '/brand-news'
export const BRAND_COVER = '/brand-cover'
export const BRAND_COVER_LIST = '/coverList'
export const BRAND_ACTIVITY = '/brand-activity'
export const BIN = '/bin'
export const BANK = '/heroSelling'
export const RECYCLE = '/recycle'
export const PRESET = '/preset'
export const STEP = '/step'
export const PRODUCT_FEATURE = '/product-feature'
export const LOCATION = '/location'
export const USER_ANNOUNCEMENT = '/app-user-announcement'
export const APP_VERSION = '/app-version'
export const REPORT_PROBLEM = '/problem-report'
export const NOTIFICATION = '/notification'
export const REWARD = '/reward'
export const EQUIPMENT = '/equipment'
export const PDPA = '/pd-pa'
export const LOG_CONTRACT = '/logContract'
export const PACKAGE = '/package'
export const SUBSCRIPTION_PACKAGE = '/subscription-package'
export const PLAN = '/plan'
export const SUBSCRIPTION_PLAN = '/subscription-plan'
export const PRICE_DASHBOARD = '/admin/dashboard'
export const PRICE = '/admin/prices'
export const PRICE_PUBLIC = '/prices'
export const PRICE_GROUP = '/admin/groups'
export const PRICE_SCHEDULE = '/admin/schedules'
export const PRICE_LOG = '/admin/logs'
export const TIER_FEATURE = '/tier-feature'
export const CUSTOMER_TAG_GLOBAL = '/customer-tag/global'
export const API_PARTNER = '/partner'
export const PRICE_GROUP_TIER_ACCESS = '/price-group-tier-access'
export const PRICE_GROUP_TIER_ACCESS_BY_SLUG =
  '/price-group-tier-access/by-slug'
